import { createFileRoute } from '@tanstack/react-router';
import { NotificationPrefsScreen } from '@/features/notifications/NotificationPrefsScreen.tsx';
import { requireAuth } from '@/features/auth/guard.ts';

export const Route = createFileRoute('/_app/profile/notifications')({
  beforeLoad: requireAuth,
  component: NotificationPrefsScreen,
});
